exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content[data-v-2ab2c393]{padding:20px}.route-error[data-v-2ab2c393]{color:#ff4500}", ""]);

// exports
